export enum AppRoute {
    LOGIN = 'login',
    FORGOT_PASSWORD = 'forgot-password',
    CREATE_NEW_PASSWORD = 'create-new-password',
}

export const VALID_UNAUTHENTICATED_ROUTES = ['/', `/${AppRoute.LOGIN}`, `/${AppRoute.FORGOT_PASSWORD}`, `/${AppRoute.CREATE_NEW_PASSWORD}`];
